import axios from 'axios';
import { getLanguage } from '../i18n';
import {
  ADMIN_AUTH_EXPIRED_EVENT,
  clearAdminToken,
  getAdminToken,
} from '../config/adminAuth';

const baseURL = process.env.REACT_APP_API_BASE_URL || '';

if (process.env.NODE_ENV === 'development' && !baseURL) {
  console.warn(
    '[API] REACT_APP_API_BASE_URL이 설정되지 않았습니다. ' +
      '요청이 React 개발 서버(localhost:3000)로 가서 404가 발생할 수 있습니다. ' +
      '프로젝트 루트에 .env 파일을 만들고 npm start를 다시 실행하세요.'
  );
}

const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const isAdminApi = (url = '') => url.startsWith('/admin/') && url !== '/admin/login';

apiClient.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token && isAdminApi(config.url)) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 관리자 토큰 만료/무효 → 토큰 삭제 후 로그인 화면으로
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && isAdminApi(error.config?.url)) {
      clearAdminToken();
      window.dispatchEvent(new Event(ADMIN_AUTH_EXPIRED_EVENT));
    }
    return Promise.reject(error);
  }
);

const HANGUL = /[\u3131-\uD79D]/;

/** 서버 오류 메시지. 서버 메시지는 한국어이므로 영어 화면에서는 fallback(번역된 화면 문구)을 쓴다 */
export function getApiErrorMessage(error, fallback) {
  const data = error?.response?.data;
  const message =
    (typeof data === 'string' && data.trim() ? data : null) ||
    data?.message ||
    data?.error ||
    error?.message;
  if (!message) return fallback;
  if (getLanguage() !== 'ko' && HANGUL.test(message) && fallback) return fallback;
  return message;
}

export default apiClient;
